import { useState } from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import Sidebar from "../pages/Sidebar";
import Header from "../pages/Header";

const Layout = () => {
  const [open, setOpen] = useState(false);

  const toggleDrawer = () => setOpen((prev) => !prev);

  return (
    <Box sx={{ display: "flex" }}>
      <Sidebar open={open} toggleDrawer={toggleDrawer} />
      <Header open={open} toggleDrawer={toggleDrawer} />

      <Box
        sx={{
          mt: "60px",
          p: 2,
          width: "100%",
          minHeight: "100vh",
          backgroundColor: "#f1f5f9",
          transition: "0.3s",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default Layout;
